import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIcoCloseRound = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 100,
	height: 100,
	fill: "#9095B5",
	viewBox: "0 0 515.94 515.94",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M-0 257.97c0,-142.42 115.54,-257.97 257.97,-257.97 142.42,0 257.97,115.55 257.97,257.97 0,142.43 -115.55,257.97 -257.97,257.97 -142.43,0 -257.97,-115.54 -257.97,-257.97zm351.37 -93.41c7.75,7.75 7.75,20.32 0,28.07l-65.34 65.34 65.34 65.34c7.75,7.75 7.75,20.32 0,28.07 -7.74,7.75 -20.31,7.75 -28.06,0l-65.34 -65.34 -65.35 65.34c-7.75,7.75 -20.31,7.75 -28.06,0 -7.75,-7.75 -7.75,-20.32 0,-28.07l65.34 -65.34 -65.34 -65.34c-7.75,-7.75 -7.75,-20.32 0,-28.07 7.75,-7.75 20.31,-7.75 28.06,0l65.35 65.34 65.34 -65.34c7.75,-7.75 20.32,-7.75 28.06,0zm-93.4 -124.87c-120.51,0 -218.28,97.77 -218.28,218.28 0,120.5 97.77,218.28 218.28,218.28 120.5,0 218.28,-97.78 218.28,-218.28 0,-120.51 -97.78,-218.28 -218.28,-218.28z" })
});
export default SvgIcoCloseRound;
